import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { useInstallationContext } from '../../context/installation';
import { useUserPermissionsContext } from '../../integrations/lavva/context/user-permissions';

export const useUserPermissions = (installationId?: string) => {
  const { userPermissions } = useUserPermissionsContext();
  const { selectedInstallationId } = useInstallationContext();

  const permissions: Record<string, boolean> = useMemo(() => {
    if (isEmpty(userPermissions)) return {};
    const id = installationId || selectedInstallationId || '';

    return id ? userPermissions[id] || {} : {};
  }, [selectedInstallationId, installationId, userPermissions]);

  return {
    permissions,
  };
};
